import {
  GET_LIVREURS,
  API_RESPONSE_SUCCESS,
  API_RESPONSE_ERROR,

  ADD_LIVREUR_SUCCESS,
  ADD_LIVREUR_FAIL,
  
  UPDATE_LIVREUR_SUCCESS,
  UPDATE_LIVREUR_FAIL,
} from "./actionType";

const INIT_STATE = {
  livreurs: [],
  error: {},
};

const Livreur = (state = INIT_STATE, action) => {
  switch (action.type) {
    case API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case GET_LIVREURS:
          return {
            ...state,
            livreurs: action.payload.data,
            isLivreurCreated: false,
            isLivreurSuccess: true
          };
        
        default:
          return { ...state };
      }
    case API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case GET_LIVREURS:
          return {
            ...state,
            error: action.payload.error,
            isLivreurCreated: false,
            isLivreurSuccess: false
          };
        
        default:
          return { ...state };
      }

    case ADD_LIVREUR_SUCCESS:
      return {
        ...state,
        isLivreurCreated: true,
        livreurs: [...state.livreurs, action.payload.data],
        isLivreurAdd: true,
        isLivreurAddFail: false
      };

    case ADD_LIVREUR_FAIL:
      return {
        ...state,
        error: action.payload,
        isLivreurAdd: false,
        isLivreurAddFail: true
      };

    case UPDATE_LIVREUR_SUCCESS:
      return {
        ...state,
        livreurs: state.livreurs.map(livreur =>
          livreur.id === action.payload.id
            ? { ...livreur, ...action.payload }
            : livreur
        ),
        isLivreurUpdate: true,
        isLivreurUpdateFail: false
      };

    case UPDATE_LIVREUR_FAIL:
      return {
        ...state,
        error: action.payload,
        isLivreurUpdate: false,
        isLivreurUpdateFail: true
      };

    default:
      return { ...state };
  }
};

export default Livreur;
